module.exports = __webpack_public_path__ + "static/img/本馆概况.06183ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/本馆概况.png
// module id = Q3uM
// module chunks = 1